export default __webpack_public_path__ + "static/media/MP0037.367ab8c2.jpg";